import { POSSIBLE_CSV_MIMETYPES } from "constant/app";
import { BulkDeviceRegistrationSample } from "fleet/view/device/bulk-device-registration-sample";
import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import {
  Button,
  Col,
  FormLabel,
  FormControl,
  FormGroup,
  FormText,
  Row,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { BackButton } from "ui/button/back";
import { Notification } from "ui/notification";
import { getErrorDetails, getErrorMessage, getFormErrors } from "util/response";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";

class BulkDeviceRegisterPage extends React.PureComponent {
  static get propTypes() {
    return {
      bulkRegisterDevices: PropTypes.func.isRequired,
    };
  }

  constructor() {
    super();

    this.state = {
      ...getFormErrors(),
      errorDetails: "",
      errorMessage: "",
      successMessage: "",
      uploading: false,
    };

    this.file = null;

    this._handleSuccess = this._handleSuccess.bind(this);
    this._resetMessages = this._resetMessages.bind(this);
    this._startUpload = this._startUpload.bind(this);
    this._submit = this._submit.bind(this);
  }

  _handleSuccess(response) {
    const successMessage = (
      <div>
        <ul>
          {response.map((r, i) => (
            <li key={i}>{r.message}</li>
          ))}
        </ul>
      </div>
    );

    this.setState({
      successMessage,
      errorDetails: "",
      errorMessage: "",
      ...getFormErrors(),
    });
  }

  _resetMessages() {
    this.setState({
      errorDetails: "",
      errorMessage: "",
      successMessage: "",
      ...getFormErrors(),
    });
  }

  _startUpload(file) {
    this.setState({ uploading: true }, this._uploadAction.bind(this, file));
  }

  _submit() {
    const file = get(this.file, "files.0", null);
    if (!file) {
      this.setState({
        formErrors: {
          file: "Please select a file.",
        },
      });

      return;
    }

    if (file.type && !POSSIBLE_CSV_MIMETYPES.includes(file.type)) {
      this.setState({
        formErrors: {
          file: "A valid .csv file is required.",
        },
      });
      return;
    }

    this._startUpload(file);
  }

  _uploadAction(file) {
    const { bulkRegisterDevices } = this.props;

    const serviceArgs = { file };

    return bulkRegisterDevices(serviceArgs)
      .then(this._handleSuccess)
      .catch((resp) => {
        const errorDetails = getErrorDetails(resp);
        const errorMessage = errorDetails
          ? "Error details"
          : getErrorMessage(resp);

        this.setState({
          errorDetails,
          errorMessage,
          ...getFormErrors(resp),
        });
      })
      .finally(() => {
        this.setState({ uploading: false });
      });
  }

  render() {
    const downloadButton = <BulkDeviceRegistrationSample />;
    const {
      errorDetails,
      errorMessage,
      formErrors,
      successMessage,
      uploading,
    } = this.state;

    return (
      <Page title="Bulk Register Devices" toolbox={downloadButton}>
        <Box noHeader={true}>
          <Row>
            <Col xs={6}>
              <Notification
                error={errorMessage}
                errorChildren={errorDetails}
                success={successMessage}
                successChildren={<Link to="/devices">Device List</Link>}
              />
              <Row>
                <Col xs={12}>
                  <FormGroup
                    controlId="file"
                  >
                    <FormLabel>Upload .csv file</FormLabel>
                    <FormControl
                      type="file"
                      accept=".csv, .txt, text/plain, text/csv"
                      ref={(elem) => {
                        this.file = elem;
                      }}
                      name="file"
                      onChange={this._resetMessages}
                      disabled={uploading}
                      isInvalid={!!formErrors.file}
                    />
                    <FormText>
                      <p>
                        Select the .csv file of devices you want to register.
                      </p>
                    </FormText>
                    <FormControl.Feedback type="invalid">
                      {formErrors.file}
                    </FormControl.Feedback>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <BackButton />
                  <Button
                    variant="primary"
                    onClick={this._submit}
                    disabled={uploading}
                  >
                    Register
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Box>
      </Page>
    );
  }
}

export { BulkDeviceRegisterPage };
